class ScrollingAnnouncementBar extends HTMLElement {
  connectedCallback() {
    if (this.querySelector('.sa-track')) return;

    const items = [...this.querySelectorAll('.sa-item')];
    if (items.length === 0) return;

    const speed = parseInt(this.dataset.speed ?? '5', 10);

    // offsetWidth is 0 while hidden (e.g. hide-on-desktop/mobile), which would
    // otherwise divide by zero below and loop forever building clones.
    const build = () => {
      if (this.offsetWidth === 0) return false;

      const track = document.createElement('div');
      track.className = 'sa-track';

      const group = document.createElement('div');
      group.className = 'sa-group';
      items.forEach(item => group.appendChild(item));

      track.appendChild(group);
      this.appendChild(track);

      // Force layout so we can measure the group width
      const groupWidth = group.offsetWidth;

      // Fill at least 2× the viewport so there's always content visible during the loop
      const copies = Math.ceil((window.innerWidth * 2) / groupWidth) + 1;
      for (let i = 0; i < copies; i++) {
        const clone = group.cloneNode(true);
        if (clone instanceof HTMLElement) clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      // Animate by exactly one group width for a seamless loop
      const duration = speed * items.length;
      track.style.setProperty('--sa-duration', `${duration}s`);
      track.style.setProperty('--sa-shift', `${groupWidth}px`);

      this.addEventListener('mouseenter', () => track.classList.add('sa-track--paused'));
      this.addEventListener('mouseleave', () => track.classList.remove('sa-track--paused'));
      document.addEventListener('visibilitychange', () => {
        track.classList.toggle('sa-track--paused', document.hidden);
      });

      return true;
    };

    if (build()) return;

    // Hidden at connect time (e.g. hide-on-desktop) — build once it becomes visible.
    const observer = new ResizeObserver(() => {
      if (build()) observer.disconnect();
    });
    observer.observe(this);
  }
}

customElements.define('scrolling-announcement-bar', ScrollingAnnouncementBar);
